jQuery($ => {
	const $counts = $('.badge-count[data-count]');
	let i = 0, types = [], hidden_counts = [];

	if($counts.length){
		try {
			hidden_counts = sessionStorage.getItem('hidden_counts');
			if(!_.isArray(hidden_counts)){
				hidden_counts = hidden_counts.split(',');
			}
		} catch(e) {}

		$counts.each(function(){
			types.push($(this).data('count'));
		});

		const queryString = $.param({ types: types });
		$.getJSON('/ajax/counts?' + queryString, function(data){
			$counts.each(function(){
				let count = $(this).data('count');
				if(data.hasOwnProperty(count)){
					if(parseInt(data[count]) > 0){
						$(this).text(data[count]).removeClass('d-none');

						if($($(this).data('container')).length){
							if(_.indexOf(hidden_counts, count) === -1){
								$($(this).data('container')).removeClass('d-none');
							}

							if($($(this).data('container')).find('[data-count-text]').length){
								let counterEl = $($(this).data('container')).find('[data-count-text]');
								let text = parseInt(data[$(this).data('count')]) === 1 ? counterEl.data('singular') : counterEl.data('plural');
								counterEl.text(text);

								$($(this).data('container')).on('closed.bs.alert', function () {
									try {
										hidden_counts.push(count);
										sessionStorage.setItem('hidden_counts', hidden_counts);
									} catch(e) {}
							  	});
							}
						}
					}
				}
			});
		});
	}
});
